<template>
	<page>
		<module enable-flex>
			<m-operate>
				<c-button color="main" v-if="auth('b_mall_ad_position_edit')" prepend-icon="tf-add" @click="$refs.adPositionEdit.open()">添加广告位</c-button>
			</m-operate>

			<c-table ref="list" height="grow" :paging="false">

				<c-table-column
					label="位置标识"
					name="position_code"
					width="160"
					fixed="left"
				></c-table-column>

				<c-table-column
					label="位置名称"
					name="position_name"
					width="200"
				></c-table-column>

				<c-table-column
					label="用途(useType)"
					width="120"
				>
					<template #default="{data}">
						<span>{{ formatUseType(data.position_code) }}</span>
					</template>
				</c-table-column>

				<c-table-column
					label="尺寸(宽x高)"
					width="120"
				>
					<template #default="{data}">
						<span v-if="data.width && data.height">{{ data.width }}x{{ data.height }}</span>
						<span v-else>-</span>
					</template>
				</c-table-column>

				<c-table-column
					label="排序号"
					name="sort_no"
					width="100"
				></c-table-column>

				<c-table-column
					label="状态"
					name="state"
					width="100"
					fixed="right"
				>
					<template #default="{data}">
						<c-switch v-if="auth('b_mall_ad_position_state')" v-model="data.state" :state-value="[1, 2]"
							:state-text="['启用','禁用']"
							@beforeChange="stateHandle(arguments[0], arguments[1], data)"></c-switch>
						<c-state v-else dict="disableEnableDic" :value="data.state"></c-state>
					</template>
				</c-table-column>

				<c-table-column
					label="备注"
					name="remark"
					width="200"
				>
					<template #default="{data}">
						<span v-if="data.remark" class="ellipsis" :title="data.remark">{{ data.remark }}</span>
						<span v-else>-</span>
					</template>
				</c-table-column>

				<c-table-column
					type="button"
					label="操作"
					width="145"
					button-limit="6"
					fixed="right"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_mall_ad_position_edit')" icon="tf-edit" @click="$refs.adPositionEdit.open(data)">编辑</c-table-button>
						<c-table-button v-if="auth('b_mall_ad_position_del')" icon="tf-trash" color="red" @click="removePosition(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</c-table>
			<!--新增/编辑广告位弹窗-->
			<ad-position-edit ref="adPositionEdit" @resolve="$refs.list.update()"></ad-position-edit>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	import adPositionEdit from "@/pages/mall/ad_position_edit.vue";

	export default {
		components: {
			adPositionEdit,
		},
		computed: {
			...mapState(['disableEnableDic'])
		},

		data() {
			return {
			}
		},

		mounted() {
			this.searchHandle();
		},

		methods: {
			/********位置标识映射 useType 用途************/
			formatUseType(positionCode) {
				const map = {
					'banner': '轮播',
					'anpai': '暗拍专区',
					'shuma': '数码专区',
					'gz': '工作机专区', 'gongzuoji': '工作机专区',
					'gg': '黑马找货', 'heimazhaohuo': '黑马找货',
					'zy': '资源机', 'ziyuanji': '资源机',
					'lj': '靓机精选', 'liangji': '靓机精选'
				};
				return map[positionCode] || '未映射';
			},

			/********搜索************/
			searchHandle(data) {
				if (!data) {
					data = {};
				}
				this.$refs.list.load({
					url: '/mall/ad_position/list',
					data
				});
			},

			/******启禁用*********/
			stateHandle(state, next, data) {
				this.request({
					url: '/mall/ad_position/update_state',
					data: {
						id: data.id,
						state: state ? 2 : 1
					},
					loading: true,
					success: () => {
						this.$message({
							message: '操作成功',
							type: 'success'
						});
						next();
					}
				});
			},

			/******删除广告位**********/
			removePosition(data) {
				this.$confirm({
					message: '确认删除广告位【' + data.position_name + '】？删除后不可恢复',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/mall/ad_position/delete',
							data: {
								id: data.id
							},
							loading: true,
							success: data => {
								this.$message({
									message: '删除成功',
									type: 'success'
								});
								this.$refs.list.update();
							}
						});
					},
					cancel: () => {},
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
